import React from 'react';
import coachingIcons from "assets/siteIntro/aboutUs/icons/coaching.png"
import datingIcons from "assets/siteIntro/aboutUs/icons/dating.png"
import supperIcons from "assets/siteIntro/aboutUs/icons/supper.png"
import thumbsUpIcons from "assets/siteIntro/aboutUs/icons/thumbsUp.png"
import { LazyImage } from 'components/image';

const BenefitOfConnectingCS = `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/About Us/bydkltnmnycsqrto3egr`

function Index() { //${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}
    const content = [
        { icon: thumbsUpIcons, text: "Dedicated to Urban Singles of India." },
        { icon: supperIcons, text: "Hosting Curated events to enhance Indian Singles Social life." },
        { icon: datingIcons, text: "Create more success stories for Indian Singles." },
        { icon: coachingIcons, text: "Making relationship coaching accessible to everyone." },
    ]

    return (
        <div>
            <div className="flex flex-col items-center text-black">
                <div className="flex items-center justify-center w-full min-h-screen ">
                    <div className="w-[90%] flex flex-col items-center text-black">

                        <div className="w-full mt-16 lg:mt-24">
                            <div className="flex flex-wrap justify-around">
                                <div className="w-full lg:w-[35%] flex items-center justify-center pb-10 lg:pt-0">
                                    <LazyImage src={BenefitOfConnectingCS} className='w-auto h-auto lg:h-[516px]' />
                                </div>

                                <div className="w-full lg:w-[35%] text-start px-7 lg:px-0">
                                    <div className='text-lg text-subText'>WHY WE EXISTS ?</div>
                                    <div className='text-xl sm:text-2xl md:text-[32px] text-start mb-4'>Find the same vibe effortlessly</div>

                                    {content.map((item) => (
                                        <div className="flex items-center my-4 mt-6 lg:w-[400px] w-full">
                                            <img loading='lazy' src={item.icon} alt='coupleSquard' className='w-[60px] h-[60px] me-6' />
                                            <div className='text-lg'>{item.text}</div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default React.memo(Index);
